import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ToggleButtons from "./ToggleButtons";
import { useState } from "react";

const _spacing = "10px";

const QnmForm = props => {
  const [toggleOption, setToggleOption] = useState(0);

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "nameWithDob") {
      props.setQueryState(prevState => {
        return { ...prevState, [name]: value, name: null, soundex: null };
      });
    } else {
      props.setQueryState(prevState => {
        return {
          ...prevState,
          [name]: value,
          nameWithDob: null,
          dobWithName: null,
        };
      });
    }
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dobWithName: str, name: null, soundex: null };
    });
  };

  const Name = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="name-id"
        label="Name Search"
        value={props?.queryState?.name || ""}
        onChange={handleChange}
        name="name"
        helperText="Last name, First name Middle Initial"
        style={{ width: "45%" }}
      />
    );
  };

  const NameDob = () => {
    return (
      <>
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-with-dob-id"
          label="Name Search with DOB"
          value={props?.queryState?.nameWithDob || ""}
          onChange={handleChange}
          name="nameWithDob"
          helperText="Last name, First name Middle Initial"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dobWithName || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
        />
      </>
    );
  };
  const Soundex = () => {
    return (
      <TextField
        variant="outlined"
        data-cy="soundex"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="soundex-id"
        label="Soundex search"
        value={props?.queryState?.soundex || ""}
        onChange={handleChange}
        name="soundex"
        style={{ width: "45%" }}
      />
    );
  };

  const formOptions = [Name, NameDob, Soundex];

  return (
    <div
      data-testid="qnm-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[{ name: "Name" }, { name: "Name/DOB" }, { name: "Soundex" }]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
    </div>
  );
};

export default QnmForm;
